/**
 * Title panel for the Automations list page.
 */
// @todo: Migrate to @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {Button} from '@wandb/weave/components/Button';
import React, {useContext, useState} from 'react';

import {
  PremiumFeatureTooltip,
  PremiumFeatureToolTipText,
  useIsAutomationEnabled,
} from '../../../util/accounts/pricing';
import {AccountSelectorContext} from '../../Search/SearchNav/AccountSelectorContextProvider';
import {CreateTriggerDrawer} from './CreateTriggerDrawer/CreateTriggerDrawer';
import {getProjectTriggerDrawerInit} from './CreateTriggerDrawer/EventStore';
import * as S from './TriggersHeader.styles';

type TriggersHeaderProps = {
  entityName: string;
  projectID: string;
  projectName: string;
  refetchTriggers: () => Promise<any>;
};

export const TriggersHeader = ({
  entityName,
  projectID,
  projectName,
  refetchTriggers,
}: TriggersHeaderProps) => {
  const [creatingTrigger, setCreatingTrigger] = useState(false);
  const {selectedAccount} = useContext(AccountSelectorContext);
  const hasAutomationAccess = useIsAutomationEnabled(selectedAccount);

  const closeDrawer = () => {
    setCreatingTrigger(false);
  };

  return (
    <S.Header>
      <CreateTriggerDrawer
        open={creatingTrigger}
        closeDrawer={closeDrawer}
        createTriggerDrawerInit={{
          isUpdating: false,
          trigger: undefined,
          ...getProjectTriggerDrawerInit(
            entityName,
            projectID,
            projectName,
            [] // TODO: get existing automations
          ),
        }}
        refetchProjectTriggers={refetchTriggers}
        showIntercom={false} // Intercom is already displayed from Triggers page
      />

      <S.Title>Automations</S.Title>
      <S.Spacer />
      <S.CreateButton>
        <Button
          icon="add-new"
          onClick={() => {
            setCreatingTrigger(true);
          }}
          disabled={!hasAutomationAccess}
          tooltip={
            !hasAutomationAccess ? (
              <PremiumFeatureToolTipText isPremiumFeatureDisabled={true} />
            ) : undefined
          }
          variant="primary"
          size="large">
          <>
            Create automation
            <PremiumFeatureTooltip
              isPremiumFeatureDisabled={!hasAutomationAccess}
            />
          </>
        </Button>
      </S.CreateButton>
    </S.Header>
  );
};
